<!-- FIXME: Inline margin -->
<div class="wallet-ticket" style="margin-top:20px;">
    <div class="wallet-ticket__content">
        <div class="border-line"></div>

        <div class="wallet-ticket-left-content">
            <div class="wallet-ticket-left-content__items">
                <span class="title">{{'TICKET_SUMMARY_V2_TICKET_TYPE' |
                    translate}}</span>
                <span class="description" *ngIf="ticket.product_object">{{ ticket.product_object |
                    translateObjectField:'name': locale}}</span>
                <span class="description" *ngIf="ticket.product">{{ ticket.product | translateObjectField:'name':
                    locale}}</span>
            </div>

            <div class="wallet-ticket-left-content__items">
                <span class="title">{{ getMediumType() | translate}}</span>
                <span class="description" *ngIf="getMedium()">{{ getMedium() }}</span>
                <span class="description" *ngIf="!getMedium() && !isVoucher()">
                    {{'CHOOSE_MEDIUM_BELOW' | translate}}
                </span>
                <span class="description" *ngIf="isVoucher()">
                    {{'ON_VOUCHER' | translate}}
                </span>
            </div>
        </div>

        <div class="wallet-ticket-right-content">
            <div class="wallet-ticket-left-content__items price">
                <span class="title">{{'TICKET_SUMMARY_V2_PRICE' | translate}}</span>
                <span class="description" *ngIf="ticket.product_object">{{ ticket.product_object.price | moneyFormat}}
                    {{appStartupService.getCurrency() | translate}}</span>
                <span class="description" *ngIf="ticket.product">{{ ticket.product.price | moneyFormat}}
                    {{appStartupService.getCurrency() | translate}}</span>
            </div>
            <ridango-ticket-actions-dropdown *ngIf="!useInputActions && ticket.actions && ticket.actions.length !== 0"
                [actions]="ticket.actions" [type]="'WALLET'" [locale]="locale"
                (actionClicked)="actionClicked($event, ticket)">
            </ridango-ticket-actions-dropdown>
            <ridango-ticket-actions-dropdown *ngIf="useInputActions" [actions]="actions" [type]="'WALLET'"
                [locale]="locale" (actionClicked)="actionClicked($event, ticket)">
            </ridango-ticket-actions-dropdown>
        </div>
    </div>
</div>
